'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recharts = require('recharts');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./pie-chart.scss');

var _chartTooltipWrapper = require('../chart-tooltip-wrapper');

var _chartTooltipWrapper2 = _interopRequireDefault(_chartTooltipWrapper);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RADIAN = Math.PI / 180;

var SGPieChart = function (_React$Component) {
  _inherits(SGPieChart, _React$Component);

  function SGPieChart() {
    _classCallCheck(this, SGPieChart);

    return _possibleConstructorReturn(this, (SGPieChart.__proto__ || Object.getPrototypeOf(SGPieChart)).apply(this, arguments));
  }

  _createClass(SGPieChart, [{
    key: 'getDataForPieChart',
    value: function getDataForPieChart() {
      var _props = this.props,
          data = _props.data,
          idKey = _props.idKey,
          filteredElementsIds = _props.filteredElementsIds;

      return data.filter(function (item) {
        return filteredElementsIds.includes(item[idKey]);
      });
    }
  }, {
    key: 'renderCustomizedLabel',
    value: function renderCustomizedLabel(_ref) {
      var cx = _ref.cx,
          cy = _ref.cy,
          midAngle = _ref.midAngle,
          innerRadius = _ref.innerRadius,
          outerRadius = _ref.outerRadius,
          percent = _ref.percent;

      var radius = innerRadius + (outerRadius - innerRadius) / 1.5;
      var x = cx + radius * Math.cos(-midAngle * RADIAN);
      var y = cy + radius * Math.sin(-midAngle * RADIAN);

      if (!percent || percent <= 0.1) {
        return null;
      }

      return _react2.default.createElement(
        'text',
        { className: 'pie-chart__label', x: x, y: y, textAnchor: 'middle', dominantBaseline: 'central' },
        (percent * 100).toFixed(2) + '%'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          dataKey = _props2.dataKey,
          idKey = _props2.idKey,
          renderTooltip = _props2.renderTooltip,
          filteredElementsIds = _props2.filteredElementsIds,
          style = _props2.style;


      var data = this.getDataForPieChart();

      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(
          _recharts.ResponsiveContainer,
          { className: 'pie-chart-container', width: '100%', aspect: 1 },
          _react2.default.createElement(
            _recharts.PieChart,
            null,
            _react2.default.createElement(
              _recharts.Pie,
              {
                dataKey: dataKey,
                startAngle: 90,
                endAngle: -360,
                data: data,
                label: this.renderCustomizedLabel
              },
              this.props.data.map(function (entity, index) {
                if (filteredElementsIds.includes(entity[idKey])) {
                  return _react2.default.createElement(_recharts.Cell, { key: index + '-cell', fill: (0, _utils2.default)(index) });
                }

                return null;
              })
            ),
            renderTooltip && (0, _chartTooltipWrapper2.default)({ renderTooltip: renderTooltip })
          )
        )
      );
    }
  }]);

  return SGPieChart;
}(_react2.default.Component);

SGPieChart.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  filteredElementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  idKey: _propTypes2.default.string.isRequired,
  dataKey: _propTypes2.default.string.isRequired,
  renderTooltip: _propTypes2.default.func,
  style: _propTypes2.default.object
};

SGPieChart.defaultProps = {
  style: { maxWidth: '300px', maxHeight: '300px' }
};

exports.default = SGPieChart;